module.exports = __webpack_public_path__ + "img/big1-2.9536f4c4.jpg";